import React from "react";

import WorkflowFeature from "../features/admin/workflow";

function Workflow(props) {
  return <WorkflowFeature {...props} />;
}

export default Workflow;
